var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("v-autocomplete", {
        staticClass: "soli-blue-text",
        attrs: {
          items: _vm.relationships,
          "no-data-text": "No relationships found",
          multiple: "",
          chips: "",
          "deletable-chips": "",
          "item-text": "name",
          "item-value": "id",
          label: "Your relationships",
          outlined: "",
          "prepend-inner-icon": "people",
          "error-messages": _vm.errors.attending,
          "hide-details": "auto",
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (data) {
              return [
                _c("v-list-item-avatar", [
                  _c("img", { attrs: { src: data.item.profile_photo_url } }),
                ]),
                _vm._v(" "),
                _c(
                  "v-list-item-content",
                  [
                    _c("v-list-item-title", {
                      domProps: { innerHTML: _vm._s(data.item.name) },
                    }),
                    _vm._v(" "),
                    _c("v-list-item-subtitle", {
                      domProps: { innerHTML: _vm._s(data.item.email) },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.form.attending,
          callback: function ($$v) {
            _vm.$set(_vm.form, "attending", $$v)
          },
          expression: "form.attending",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }